<script>
    import { onMount } from 'svelte';

    export let content = 'placeholder';

    let textarea;

    onMount(() => {
        textarea.select();
        document.execCommand('copy');
        //console.log('mounted', content);
    });
</script>

<textarea bind:value={content} bind:this={textarea} />
